import React, { Component } from 'react';

import classnames from 'classnames';
import { Grid } from 'components/grid';
import Icon from 'components/icons';
import { I18n, translate } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import Settings from 'configs/Settings';
import { ShellContext } from 'contexts/shellContext';
import { withShellContext } from 'hoc/withShellContext';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import ContentBasePage from 'modules/content/components/ContentBasePage';
import { MembershipStore, MembershipService } from 'modules/membership';
// eslint-disable-next-line no-restricted-imports
import { onlineEventLabelHandler } from 'modules/onlineEvent/helpers';
import {
  DeepSearchService,
  UserSegmentationService
} from 'modules/userManager';
import Search from 'modules/userManager/userSearch/search/Search';
import {
  UserSegmentation,
  UsersSegmentations
} from 'modules/userManager/userSearch/segmentation';
import NewSegmentationModal from 'modules/userManager/userSearch/segmentation/NewSegmentationModal';
import BigNumbersSection from 'modules/userManager/usersList/bigNumbers/BigNumbersSection';
import PropTypes from 'prop-types';

import UsersListActions from './actions/UsersListActions';
import UsersData from './UsersData';

import './UsersManager.scss';

@inject((stores) => ({
  isMobile: stores.UiStore.isMobile,
  newSegmentationModal: stores.UserSegmentationStore.newSegmentationModal,
  segmentation: stores.UserSegmentationStore.segmentation,
  totalElements: stores.UserManagerStore.totalElements,
  productId: stores.MembershipStore.productId
}))
@observer
@translate()
class UsersManager extends Component {
  static contextType = ShellContext;

  static propTypes = {
    productId: PropTypes.number,
    isMobile: PropTypes.bool.isRequired,
    newSegmentationModal: PropTypes.bool,
    segmentation: MobxPropTypes.objectOrObservableObject,
    totalElements: PropTypes.number,
    t: PropTypes.func,
    history: PropTypes.object,
    isMembership: PropTypes.bool
  };

  componentDidMount() {
    UserSegmentationService.clear();
    DeepSearchService.clear();
  }

  handleOpenModalNewSegmentation = () =>
    UserSegmentationService.openNewSegmentationModal();

  handleUserImportButtonClick = () => {
    if (this.props.isMembership) {
      const { productId: productIdByParam } = this.context;

      window.location.href = `${Settings.app.bw}/membership/${
        MembershipService.slug
      }/members/add/${productIdByParam ?? this.props.productId}`;

      return;
    }

    this.props.history.push(ROUTES.USER.IMPORT);
  };

  get titleLabel() {
    const { totalElements } = this.props;

    if (MembershipStore.onlineEvent) {
      return onlineEventLabelHandler(
        totalElements === 1 ? 'general.user' : 'general.users'
      );
    }

    return 'users_manager.users_list.title';
  }

  get subtitleLabel() {
    const { isMembership } = this.props;

    if (MembershipStore.onlineEvent) {
      return 'online_event.big_numbers.subtitle';
    }

    if (isMembership) {
      return 'users_manager.users_list.subtitle';
    }

    return void 0;
  }

  render() {
    const { isMobile, newSegmentationModal, segmentation, totalElements, t } =
      this.props;
    const importButtonClasses = classnames(
      'hot-button hot-button--secondary _text-decoration-none _mr-md-5',
      { 'hot-button--block': isMobile },
      { 'hot-button--lg': !isMobile }
    );
    const newSegmentationButtonClasses = classnames(
      'hot-button hot-button--primary',
      { 'hot-button--block': isMobile },
      { 'hot-button--lg': !isMobile }
    );

    return (
      <ContentBasePage className="users__manager content__grid">
        <ContentBasePage.Header
          title={this.titleLabel}
          subtitle={this.subtitleLabel}
          hideBackHandler={true}
          totalElements={totalElements}
          className="_align-items-center _mb-6"
          contentClassName="_w-full"
        >
          <div className="_d-flex _flex-column _flex-lg-row _justify-content-lg-end _w-full">
            <button
              aria-label={t('users_manager.users_list.header.users_import', {
                checkOnlineEvent: true
              })}
              onClick={this.handleUserImportButtonClick}
              className={importButtonClasses}
            >
              <Icon
                prefix="fal"
                iconName="arrow-alt-to-top"
                className="_mr-2"
              />
              <I18n
                label="users_manager.users_list.header.users_import"
                checkOnlineEvent
              />
            </button>

            <button
              aria-label={t('users_manager.users_list.header.new_segmentation')}
              data-test="button-modal-segmentation"
              className={newSegmentationButtonClasses}
              onClick={this.handleOpenModalNewSegmentation}
            >
              <Icon prefix="fal" iconName="plus" className="_mr-2" />
              <I18n label="users_manager.users_list.header.new_segmentation" />
            </button>
          </div>
        </ContentBasePage.Header>

        <UsersSegmentations>
          <Grid nopadding block>
            <div className="users_manager__header">
              {UserSegmentationService.hasSegmentation && (
                <UserSegmentation segmentation={segmentation} />
              )}
              <Search />
              <BigNumbersSection />
              <UsersListActions />
            </div>

            <UsersData />
          </Grid>
        </UsersSegmentations>

        {newSegmentationModal && <NewSegmentationModal />}
      </ContentBasePage>
    );
  }
}

export default withShellContext(UsersManager);
